export const NOT_STARTED = {
  name: 'NOT_STARTED',
  display: 'Not Started'
};

export const IN_PROGRESS = {
  name: 'IN_PROGRESS',
  display: 'In Progress'
};

export const APPROVAL_REQUIRED = {
  name: 'APPROVAL_REQUIRED',
  display: 'Approval Required'
};

export const CUSTOMER_APPROVAL_REQUIRED = {
  name: 'CUSTOMER_APPROVAL_REQUIRED',
  display: 'Customer Approval Required'
};

export const COMPLETED = {
  name: 'COMPLETED',
  display: 'Completed'
};
